import { CompanyService } from './../../core/services/company/company.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  Renderer2,
  ViewChild
  } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IContribuyente } from './../../core/models/business-information/ibusiness-information';
import { InformationFormatting } from './../../core/helpers/information-formatting/information-formatting';
import { IUser } from './../../core/models/user/user';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { map } from 'rxjs/operators';
import { RoutingPath } from './../../configs/routing-path';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-nav-user',
    templateUrl: './nav-user.component.html',
    styleUrls: ['./nav-user.component.scss'],
    standalone: false
})
export class NavUserComponent implements OnInit {

  public userloggedin: IUser;
  public companyData: IContribuyente;
  public dropActive = false;
  public change;
  public $companyData: Observable<IContribuyente>;

  @ViewChild('dropAvatar', {static: true}) dropAvatar: ElementRef;
  @ViewChild('elmAvatar', {static: false}) elmAvatar: ElementRef;
  @ViewChild('menuContrasena', {static: false}) menuContrasena: ElementRef;

  @Output() overlayActive: EventEmitter<boolean>;

  constructor(
    private _storage: LocalStorageService,
    private _renderer: Renderer2,
    private _company: CompanyService, private render : Renderer2) {

    this.overlayActive = new EventEmitter();
  }

  ngOnInit() {
    this.userloggedin = this._storage.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
    this.getBusinnessInformation();
    this.companyData = this._storage.getItemJSON(environment.LOCAL_STORAGE.BUSINESS_INFORMATION);
   
    this.dropDown();
    this.change = RoutingPath.appRouting.components.user.path + '/' + RoutingPath.appRouting.components.user.pages.change_password.path;
  }

  getBusinnessInformation() {
    this._company.getBusinnessInformation(
      InformationFormatting.returnNameDocumentCompany(this.userloggedin.docTypeCompany),
      this.userloggedin.docNumberCompany,
      this.userloggedin.checkDigit
    ).pipe(
      map((response) => {
        this.companyData = response.body.data[0].contribuyente;
        this._storage.stringifyItem(environment.LOCAL_STORAGE.BUSINESS_INFORMATION, this.companyData);
      })
    ).subscribe();
  }

  dropDown() {
    this._renderer.listen('window', 'click', (event) => {
      if (this.elmAvatar!=undefined && event.target !== this.elmAvatar.nativeElement) {

        this._renderer.removeClass(this.dropAvatar.nativeElement, 'c-dropdown--active');

        this.dropActive = false;

        this.overlayActive.emit(this.dropActive);
      }
    });
  }

  clickToggle(e) {
    this.dropActive = !this.dropActive;
    this.overlayActive.emit(this.dropActive);
    let expand = (this.dropActive) ? 'true' : 'false';
    this.render.removeAttribute(this.menuContrasena.nativeElement,'aria-expanded');
    this.render.setAttribute(this.menuContrasena.nativeElement,'aria-expanded',expand);

  }

  hiddeToggle() {
    if (this.dropActive) this.dropActive = false;
    this.overlayActive.emit(this.dropActive);
    this.render.removeAttribute(this.menuContrasena.nativeElement,'aria-expanded');
    this.render.setAttribute(this.menuContrasena.nativeElement,'aria-expanded',"false");
  }

}
